<div class="tabs" [class.three_tabs]="tabsList.length === 3" [class.small]="isSmall">
  <ion-button [class.first]="first" [class.last]="last" [class.selected]="tab === selectedtab"
    *ngFor="let tab of tabsList; let first = first; let last = last" (click)="selectTab(tab)" fill="clear">
    <ion-icon *ngIf="isSmall" [name]="'dp-' + tab"></ion-icon>
    {{translatePath + tab | translate: {default: tab} }}
  </ion-button>
</div>